import React, {useEffect, useRef, useState} from 'react';
import {Calendar} from 'react-date-range';
import './CreateVolumeCampaign.css';
import {useFormValidation} from '../../../../../hooks/useFormValidation/useFormValidation';
import CampaignsPreviewPhone from "../../CampaignsPreviewPhone/CampaignsPreviewPhone";
import AccountLimitReached from "../../../../Modal/AccounLimitReached/AccountLimitReached";
import Message from "../../../../Modal/Message/Message";
import {CAMPAIGNS_TYPE} from "../../CreateCampaignsContent/CreateCampaignsContent";
import Spinner from 'react-bootstrap/Spinner';


const MESSAGES = {
    noUserTargeted: 'You are targeting on wrong way. Change conditions and try again.',
    tooMuchUserTargeted: 'Can not be sent to more than 10 000 users at once. Please split you data set.'
};

const INITIAL_STATE = {
    visitedMoreThanValue: '',
    visitedLessThanValue: '',
    spentMoreThanValue: '',
    spentLessThanValue: '',
    image: '',
    offerValue: '',
    city: '',
    storeId: '',
};
const CreateVolumeCampaign = (props) => {
    // svi ovi props nam dolaze iz index.js Dashboard cudno je sto prosledjujemo kroz citavu strukturu ali za sada je tako
    // takodje podatke potrebne za slanje kampanje takodje vracamo do index.js Dashboard jer nam je tu sva logika i state
    // !!! poraditi na resenjima zbog ovliko nestovanja i prolazaka sa propsom, PROPS DRILLING vrlo losa praksa jbg
    const {handleCampaignData, handleModalData, closeModal, companyData, visits, companyLogoURL, loading} = props;
    const [numberOfUserToTarget, setNumberOfUserToTarget] = useState(0);
    const [resetFileInputValue, setResetFileInputValue] = useState('');
    const [deepCloneVisits, setDeepCloneVisits] = useState([]);
    const isFirstRun = useRef(true);
    const formRef = useRef();

    const passCampaignDataToParent = () => {
        const maximumNumberOfMessagesCompanyCanSend = companyData.accountBalance / companyData.messagePrice;
        if (numberOfUserToTarget < 1) {
            // nula targetiranih korisnika samo poruka
            const modalComponent = <Message message={MESSAGES.noUserTargeted}/>;
            handleModalData(modalComponent);
            return
        }
        if (numberOfUserToTarget > 10000) {
            const modalComponent = <Message message={MESSAGES.tooMuchUserTargeted}/>;
            handleModalData(modalComponent);
            return
        }
        if (numberOfUserToTarget > maximumNumberOfMessagesCompanyCanSend) {
            // korisnik pokusava da posalje vise poruka nego sto ima kinte na racunu, prikazujemo modal
            const modalComponent = <AccountLimitReached
                numberOfUserToTarget={numberOfUserToTarget}
                maximumNumberOfMessagesCompanyCanSend={maximumNumberOfMessagesCompanyCanSend}
                closeModal={closeModal}/>;

            handleModalData(modalComponent);
        } else {
            // saljemo podatke za kampanju
            const newCampaignsObject = {
                campaignType: CAMPAIGNS_TYPE.volumeCampaign,
                visitedMoreThanValue: values.visitedMoreThanValue,
                visitedLessThanValue: values.visitedLessThanValue,
                spentMoreThanValue: values.spentMoreThanValue,
                spentLessThanValue: values.spentLessThanValue,
                activeInLastValue: '',
                inactiveInLastValue: '',
                offerValue: values.offerValue,
                time: '',
                numberOfUserToTarget: numberOfUserToTarget,
                city: values.city,
                storeId: values.storeId,
                image: values.image,
            };
            handleCampaignData(newCampaignsObject);
            resetForm(INITIAL_STATE);
            formRef.current.reset();
        }
    };

    const {handleChange, handleSubmit, handleBlur, resetForm, errors, isSubmitting, values} = useFormValidation(INITIAL_STATE, passCampaignDataToParent);

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        let timer = setTimeout(() => filterNumberOfTargetedUser(), 500);
        return () => {
            clearTimeout(timer);
          };
    }, [values.visitedMoreThanValue, 
        values.visitedLessThanValue, 
        values.spentMoreThanValue, 
        values.spentLessThanValue, 
        values.city, 
        values.storeId]);

    const filterNumberOfTargetedUser = () =>  {
        let tempVisitsData = [];
        tempVisitsData = visits.filter(visit => {
            const listOfCities = visit.listOfCities.split(',');
            const listOfStoresId = visit.listOfStoresId.split(',');
    
            const visitedMoreThanValueCheck = values.visitedMoreThanValue !== "" ? parseInt(visit.count) >= parseInt(values.visitedMoreThanValue) : true;
            const visitedLessThanValueCheck = values.visitedLessThanValue !== "" ? parseInt(visit.count) <= parseInt(values.visitedLessThanValue) : true;
            const spentMoreThanValueCheck = values.spentMoreThanValue !== "" ? parseInt(visit.value) >= parseInt(values.spentMoreThanValue) : true;
            const spentLessThanValueCheck = values.spentLessThanValue !== "" ? parseInt(visit.value) <= parseInt(values.spentLessThanValue) : true;
            const cityCheck = values.city !== "" ? listOfCities.includes(values.city) : true;
            const storeIdCheck = values.storeId !== "" ? listOfStoresId.includes(values.storeId) : true;

            if( visitedMoreThanValueCheck && 
                visitedLessThanValueCheck && 
                spentMoreThanValueCheck && 
                spentLessThanValueCheck && 
                cityCheck && 
                storeIdCheck) {
                    return visit;
                }
        });
        setNumberOfUserToTarget(tempVisitsData.length);
    }

    const resetsTheFileInput = () => {
        let randomString = Math.random().toString(36);
        setResetFileInputValue(randomString);
        const event = {
            target: {
                name: 'image',
                value: null,
            }
        };
        handleChange(event)
    };

    return (
        <div className='campaign-container'>
            <div className='campaign-wrapper'>
                <div className='campaign-form-wrapper'>
                    <form ref={formRef} className='campaign-form' onSubmit={handleSubmit}>
                        <div className='campaign-account-balance-wrapper'>
                            <p className='campaign-account-balance'>Stanje na računu
                                : {companyData.accountBalance} RSD</p>
                        </div>
                        <div className='campaign-form-section'>
                            <p className={'error-message'}>{errors.visitedMoreThanValue}</p>
                            <label className='campaign-form-label' htmlFor="">Visits #:</label>
                            <input
                                className={`campaign-form-input ${errors.visitedMoreThanValue && 'error-input'}`}
                                name='visitedMoreThanValue'
                                type="number"
                                placeholder='min'
                                autoComplete='off'
                                value={values.visitedMoreThanValue}
                                onBlur={handleBlur}
                                onChange={handleChange}/>
                            {' - '}
                            <input className='campaign-form-input'
                                   name='visitedLessThanValue'
                                   type="number"
                                   placeholder='max'
                                   autoComplete='off'
                                   value={values.visitedLessThanValue}
                                   onBlur={handleBlur}
                                   onChange={handleChange}/>
                        </div>
                        <div className='campaign-form-section'>
                            <p className={'error-message'}>{errors.spentMoreThanValue}</p>
                            <label className='campaign-form-label' htmlFor="">Spent value:</label>
                            <input className={`campaign-form-input ${errors.spentMoreThanValue && 'error-input'}`}
                                   name='spentMoreThanValue'
                                   type="number"
                                   placeholder='min'
                                   autoComplete='off'
                                   value={values.spentMoreThanValue}
                                   onBlur={handleBlur}
                                   onChange={handleChange}/>
                            {' - '}
                            <input className='campaign-form-input'
                                   name='spentLessThanValue'
                                   type="number"
                                   placeholder='max'
                                   autoComplete='off'
                                   value={values.spentLessThanValue}
                                   onBlur={handleBlur}
                                   onChange={handleChange}/>
                        </div>
                        {companyData.extraCampaignFields && <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">City:</label>
                            <input className='campaign-form-input'
                                   name='city'
                                   type="text"
                                   autoComplete='off'
                                   value={values.city || ''}
                                   onBlur={handleBlur}
                                   onChange={handleChange}/>
                        </div>}
                        {companyData.extraCampaignFields && <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Store ID:</label>
                            <input className='campaign-form-input'
                                   name='storeId'
                                   type="text"
                                   autoComplete='off'
                                   value={values.storeId}
                                   onBlur={handleBlur}
                                   onChange={handleChange}/>
                        </div>
                        }

                        <div className='campaign-form-section'>
                            <label className='campaign-form-label' htmlFor="">Offer:</label><br/>
                            <label className='campaign-form-label important-message' htmlFor="">Here <b>&#123;0&#125;</b> will <b>NOT</b> be replaced with UID</label>
                            <textarea className='campaign-form-textarea'
                                      name='offerValue'
                                      value={values.offerValue}
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      cols="60"
                                      rows="5"/>

                        </div>
                        <div className='campaign-form-section'>
                            <label className='campaign-form-label'>Photo:</label>
                            <button type='button' className='campaign-form-remove-selected-image' onClick={resetsTheFileInput}>X
                            </button>
                            <input className={`campaign-form-input ${errors.image && 'error-input'}`}
                                   name='image'
                                   type="file"
                                   id='image-file'
                                   key={resetFileInputValue}
                                   accept="image/jpg ,image/jpeg, image/png"
                                   onChange={handleChange}/>
                        </div>
                        <div className='campaign-form-section campaign-form-section-bottom'>
                            <div className=''>
                                <input className='campaigns-send-button' type="submit"
                                       value="Send Campaign"/>
                                {loading && <Spinner animation="border" variant="primary" />}
                            </div>
                            <div className='campaign-number-of-target'>
                                <label>Targeted number of users</label>
                                <div style={{textAlign: 'center'}}>
                                    <span>{numberOfUserToTarget}</span> / <span>{visits.length}</span>
                                </div>

                            </div>
                        </div>

                    </form>
                </div>
            </div>
            <CampaignsPreviewPhone newCampaignData={values} companyData={companyData} companyLogoURL={companyLogoURL}/>
        </div>
    )
};

export default CreateVolumeCampaign;


